import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { getProcedure } from "../../api/procedure";
import { getProcedureRole } from "../../api/procedure/getProcedureRole";
import { getStage } from "../../api/stage";
import { getPreliminaryReport } from "../../api/stage/preliminaryReport";
import { PreliminaryReports } from "../../components/Stages/PreliminaryReports";
import { useTranslationHook } from "../../hooks";
import { setLoading } from "../../store/UI";
import { Procedure, ProcedureRole } from "../../types/model/procedure";
import { PreliminaryReport, Stage } from "../../types/model/stage";

const StagePreliminaryReports = () => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();

  const { accountId, projectId, activityId, procedureId, stageId } =
    useParams<{
      accountId: string;
      projectId: string;
      activityId: string;
      procedureId: string;
      stageId: string;
    }>();

  const [stage, setStage] = useState<Stage>();
  const [preliminaryReport, setPreliminaryReport] = useState<PreliminaryReport>();
  const [procedure, setProcedure] = useState<Procedure>();
  const [procedureRole, setProcedureRole] = useState<ProcedureRole>();
  const [loadingLocal, setLoadingLocal] = useState(true);

  const session = JSON.parse(localStorage.getItem("session") || "{}");
  const currentUserId = session?.userId || null;

  useEffect(() => {
    const fetchData = async () => {
      if (!projectId || !activityId || !procedureId || !stageId) return;

      dispatch(setLoading(true));

      try {
        const [
          stageRes,
          preliminaryReportRes,
          procedureRes,
          procedureRoleRes,
        ] = await Promise.all([
          getStage(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getPreliminaryReport(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getProcedure(Number(projectId), Number(activityId), Number(procedureId)),
          getProcedureRole(Number(projectId), Number(activityId), Number(procedureId)),
        ]);

        setStage(stageRes);
        setPreliminaryReport(preliminaryReportRes);
        setProcedure(procedureRes);
        setProcedureRole(procedureRoleRes);

        enqueueSnackbar(t("stages.preliminary-reports.preliminary-reports-loaded"), {
          variant: "success",
        });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(t("stages.preliminary-reports.error-loading"), {
          variant: "error",
        });
      } finally {
        dispatch(setLoading(false));
        setLoadingLocal(false);
      }
    };

    fetchData();
  }, [projectId, activityId, procedureId, stageId, dispatch]);

  if (loadingLocal || !stage || !procedure || !procedureRole) return null;

  return (
    <PreliminaryReports
      stage={stage}
      preliminaryReport={preliminaryReport}
      procedureRole={procedureRole}
      procedure={procedure}
      accountId={Number(accountId)}
      userId={currentUserId}
      projectId={Number(projectId)}
      activityId={Number(activityId)}
      procedureId={Number(procedureId)}
    />
  );
};

export default StagePreliminaryReports;